import React, { Component } from "react";

import BsyDashboardFlowPane from "../BsyDashboardFlowPane";
import BsyDashboardFlowPaneV2 from "../BsyDashboardFlowPaneV2";
import BsyDashCarouselMap from "../BsyDashCarouselMap";
import BsyDashRecentUse from "../BsyDashRecentUse";
import BsyDashNoticeBoard from "../BsyDashNoticeBoard";
import BsyDashRichText from "../BsyDashRichText";
import BsyDashRichTextConfig from "../BsyDashRichTextConfig";

import BsyDashboardCustomApp from "../BsyDashboardCustomApp";
import BsyDashboardDockApp from "../BsyDashboardDockApp";
import BsyDashboardMyDash from "../BsyDashboardMyDash";
import BsySelect from "../../BsySelect";
import BsyDashboardSpeedyEntry from "../BsyDashboardSpeedyEntry";
import BsyDashboardCustomAppConfig from "../BsyDashboardCustomAppConfig";
import BsyDashboardRecentUseConfig from "../BsyDashboardRecentUseConfig";
import BsyDashboardDockAppConfig from "../BsyDashboardDockAppConfig";
import BsyDashboardSpeedyEntryConfig from "../BsyDashboardSpeedyEntryConfig";
import BsyDashboardNoticeBoardConfig from "../BsyDashboardNoticeBoardConfig";
import RichTextBackGroundImg from "../BsyDashRichText/richTextBackGroundImg";
import BsyDashboardCustomDashConfig from "../BsyDashboardCustomDashConfig";
import BsyDashboardCarouselMapConfig from "../BsyDashboardCarouselMapConfig";
import BsyDashboardMyDashConfig from "../BsyDashboardMyDashConfig";
import BsyDesignSpeedyEntryConfig from "../BsyDesignSpeedyEntryConfig";
import BsySlidePane from "../../BsySlidePane";
import BsyMsgBubble from "../../BsyMsgBubble";
import BsyDashComponent, {
  BsyDashComponentInvalid,
} from "../../dash/BsyDashComponent";

import BsyDialog from "../../BsyDialog";
import BsyDialogBgFull from "../../BsyDialogBgFull";
import "./index.css";
import { BsyUtils } from "../../../utils/Utils";
import BsyDashboardMyApp from "../BsyDashboardMyApp";
import BsyIconBtn from "../../BsyIconBtn";
import BsyDashboardAppGroupDesign from "../BsyDashboardAppGroupDesign";
import BsyAppExportPane from "../BsyAppExportPane";
import { CreateApp } from "../BsyDashboardMyApp/CreateApp";
import _ from "lodash";
import tipAlert from "../../../Login/BsyAlertTip/Staticize";
import classNames from "classnames";
import BsyDashboardMyFavorites from "../BsyDashboardMyFavorites";
import BsyDashboardMyFavoritesConfig from "../BsyDashboardMyFavoritesConfig";

import { createTooltip } from "../../../utils/createTooltip";
import BsySearchResult from "../../BsySearchResult";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import BsyAlert from "../../BsyAlert";
import BsyMaskLayer from "../../BsyMaskLayer";
class BsyDashboardComponent extends Component {
  static defaultProps = {
    dockApp: [],
    dockItem: [],
    dockCorp: [],
    myDash: [],
    myApp: {},
    favorites: [],
  };

  constructor(props) {
    super(props);
    const apps = (props.apps || []).filter(
      (item) => item.type !== "standardapp"
    );
    this.state = {
      block: props.block,
      id: props.block.id,
      mode: props.mode,
      customApp: props.customApp,
      dockApp: props.dockApp,
      dockItem: props.dockItem,
      flowManagementType: props.flowManagementType,
      designMode: props.designMode,
      dockCorp: props.dockCorp,
      noticeBoard: props.noticeBoard,
      carouselMap: props.carouselMap,
      recentUse: props.recentUse,
      customDash: props.customDash,
      speedyEntry: props.speedyEntry,
      designType: props.designType,
      richText: props.richText,
      myDash: props.myDash,
      myApp: props.myApp,
      preferences: props.preferences,
      apps: apps,
      RecentUseList: [],
      hasStandardAppUpdate: false,
      favorites: props.favorites || [],
    };
    this.richTextClick = "rich-text-show";
    this.layoutBtn = React.createRef();
    this.exportApp = React.createRef();
    this.boardNoticeBoardConfig = React.createRef()
    this.bsyDashboardCarouselMapConfig = React.createRef();
    this.myAppRef = React.createRef();
    this.bsyRichText = React.createRef();
    this.favoritesContext = React.createRef();
    this.bsyRichTextConfig = React.createRef();
    this.BsyDialogBgFull = "";
    this.changeStateflowManagementV2 = "combo";
    this.changeStateCarouselMap = Math.random();
    const { show, hide } = createTooltip();
    this.showTooltip = show;
    this.hideTooltip = hide;
  }

  componentWillUnmount() {
    this.hideTooltip();
  }

  componentDidMount() {
    this.setState({
      dockApp:
        this.props.dockApp && this.props.dockApp.corp
          ? this.props.dockApp
          : this.getcacheValue(),
    });
    this.props?.getContext?.(this);
  }

  selectApp = (appinfo) => {
    if (this.props.onSelectApp) {
      this.props.onSelectApp(appinfo);
    }
  };

  onDelComponent = (component) => {
    const { block } = this.state;
    let richText = this.state.richText;
    if (this.props.onDelComponent) {
      this.props.onDelComponent(component);
    }
    if (block.id === "richText") {
      //富文本删除的时候 对应数据也要删除
      richText = {};
    }
    this.setState({
      richText: richText,
    });
  };

  onCustomApp = (component) => {
    if (this.props.onCustomApp) {
      this.props.onCustomApp(component);
    }
  };

  setcacheKey = () => {
    const { block } = this.state;
    let key = `${window.FX.STATIC.corpId}-${block.id}-value`;
    return key;
  };
  setcacheValue = (val) => {
    const key = this.setcacheKey();
    BsyUtils.Store.set(key, val);
  };
  getcacheValue = () => {
    const key = this.setcacheKey();
    return BsyUtils.Store.get(key) || {};
  };

  onDockApp = (component) => {
    if (this.props.onDockApp) {
      this.props.onDockApp(component);
    }
    this.props.onRefreshChars && this.props.onRefreshChars();
  };

  onMyDash = (component) => {
    if (this.props.onMyDash) {
      this.props.onMyDash(component);
    }
  };

  onSpeedyEntry = (component) => {
    if (this.props.onSpeedyEntry) {
      this.props.onSpeedyEntry(component);
    }
  };
  onEmitCarousel = (component, block) => {
    this.setState(
      {
        carouselMap: component,
        block: block,
      },
      () => {
        if (this.props.carouselMap) {
          this.props.onEmitCarousel(component, block);
        }
      }
    );
    this.changeStateCarouselMap = Math.random();
  };
  emitSaveBoardNotice = (component) => {
    this.setState(
      {
        noticeBoard: component,
      },
      () => {
        if (this.props.carouselMap) {
          this.props.onEmitSaveBoardNotice(component);
        }
      }
    );
  };

  onGetStyles = () => {
    //拿的应用访问默认样式
    return JSON.parse(
      '{"theme":{"name":"preset_style_light_1","highLightColor":"#0265FF","palette":"preset_1","gradation":"preset_map_1","color":"#E9E9E9","icon":1,"cardName":"preset_metric_1"},"background":{"type":"color","color":"#FFFFFF"},"fontSetting":{"titleColor":"#1F2D3D","headColor":"#5E6D82","textColor":"#1F2D3D","textAlign":"default"}}'
    );
  };
  onGetRecentUseValue = () => {
    React.axios("/dashboard/get_recent_access")
      .then((res) => {
        let list = {
          list: res.data.entry,
        };
        this.setState(
          {
            recentUse: list,
          },
          () => {
            if (this.props.carouselMap) {
              this.props.onEmitRecentUseValue(list);
            }
          }
        );
      })
      .catch((err) => {
        tipAlert({
          type: "warning",
          msg: err,
        });
      })
      .finally(() => { });
  };
  flowManagementTypeChange = (type) => {
    window.$(".bsy-msg-bubble").remove();
    this.props.onEmitFlowManagementType(type);
    this.setState(
      {
        flowManagementType: type,
      },
      () => {
        this.changeStateflowManagementV2 = Math.random();
      }
    );
  };
  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    const apps = (nextProps.apps || []).filter(
      (item) => item.type !== "standardapp"
    );
    switch (this.state.id) {
      case "myDash":
        this.setState({
          myDash: nextProps.myDash,
          apps: apps,
        });
        break;
      case "carouselMap":
        this.setState({
          carouselMap: nextProps.carouselMap,
        });
        if (this.props.mode === "edit") {
          this.changeStateCarouselMap = Math.random(); //切换工作台的时候刷新默认图片
        }
        break;
      case "dockApp":
        this.setState({
          dockItem: nextProps.dockItem,
        });
        break;

      default:
        this.setState({
          apps: apps,
          flowManagementType: this.props.flowManagementType,
          preferences: this.props.preferences,
          block: this.props.block,
        });
    }
  }

  SpeedyEntryValue = (val) => {
    this.speedyEntry = val;
  };

  CustomAppValue = (val) => {
    this.customApp = val;
  };

  DockAppValue = (val) => {
    this.dockApp = val;
  };

  CustomDashValue = (customDash, val) => {
    this.customDash = customDash;
    this.block = val;
  };

  MyDashValue = (MyDash, val) => {
    this.myDash = MyDash;
    this.block = val;
  };

  FavoritesValue = (favorites, val) => {
    this.favorites = favorites;
    this.block = val;
  };

  getRecentUseValue = () => { };
  renderCofigPane = () => {
    const {
      block,
      speedyEntry,
      customDash,
      customApp,
      dockApp,
      myDash,
      carouselMap,
      recentUse,
      favorites,
    } = this.state;
    switch (block.id) {
      case "noticeBoard": {
        return (
          <BsyDashboardNoticeBoardConfig
            speedyEntry={speedyEntry}
            getValue={this.SpeedyEntryValue}
          />
        );
      }
      case "speedyEntry": {
        return (
          <BsyDashboardSpeedyEntryConfig
            speedyEntry={speedyEntry}
            getValue={this.SpeedyEntryValue}
          />
        );
      }
      case "myDash": {
        return (
          <BsyDashboardMyDashConfig
            customDash={myDash}
            block={block}
            getValue={this.MyDashValue}
          />
        );
      }
      case "favorites": {
        return (
          <BsyDashboardMyFavoritesConfig
            favorites={favorites}
            block={block}
            getValue={this.FavoritesValue}
          />
        );
      }
      case "customDash": {
        return (
          <BsyDashboardCustomDashConfig
            customDash={customDash}
            block={block}
            getValue={this.CustomDashValue}
          />
        );
      }
      case "carouselMap": {
        return (
          <BsyDashboardCarouselMapConfig
            ref={this.bsyDashboardCarouselMapConfig}
            carouselMap={carouselMap}
            block={block}
          />
        );
      }
      case "customApp": {
        return (
          <BsyDashboardCustomAppConfig
            customApp={customApp}
            getValue={this.CustomAppValue}
          />
        );
      }

      case "dockApp": {
        return (
          <BsyDashboardDockAppConfig
            dockApp={dockApp}
            getValue={this.DockAppValue}
          />
        );
      }
      case "recentUse": {
        return (
          <BsyDashboardRecentUseConfig
            recentUse={recentUse}
            getValue={this.DockAppValue}
          />
        );
      }
      default: {
      }
    }
    if (block.id.includes("speedyEntryV2")) {
      return (
        <BsyDashboardSpeedyEntryConfig
          speedyEntry={speedyEntry}
          getValue={this.SpeedyEntryValue}
        />
      );
    }
  };

  //

  update_custom = () => {
    // const { customApp, customDash, speedyEntry, designType } = this.state;
    // React.axios('/corp/update_custom', {
    //     "mode": designType === 'company' ? "default" : designType,
    //     speedyEntry
    // }).then(res => {
    // }).catch(res => {
    // })
  };

  getSlideContext = (context) => {
    this.BsySlideSpeedyContext = context;
  };
  getNoticeSlideContext = (context) => {
    this.BsyNoticeSlideSpeedyContext = context;
  };
  getSpeedyContext = (context) => {
    this.BsySpeedyContext = context;
  };

  saveSpeedyEntry = () => {
    const { block, preferences } = this.state;
    const { dataList, layoutStyle, title } = this.BsySpeedyContext.state;
    preferences[block.id].entries = dataList;
    preferences[block.id].layoutStyle = layoutStyle;
    preferences[block.id].title = title;
    // speedyEntry.entries = dataList;
    // speedyEntry.layoutStyle = layoutStyle;
    // speedyEntry.title = title;
    this.setState(
      {
        preferences: preferences,
      },
      () => {
        this.props.preferences && this.props.onSpeedyEntry(preferences);
      }
    );
  };

  onConfig = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const {
      block,
      flowManagementType,
      preferences,
      mode,
      richText,
      designMode,
      apps,
    } = this.state;
    let blockName = block.name;
    let _this = this;
    block.id.includes("speedyEntryV2") &&
      (blockName = React.language("speedy.entry"));
    block.id === "speedyEntry" && (blockName = React.language("speedy.entry"));
    block.id === "customApp" && (blockName = React.language("app.common"));
    block.id === "dockApp" && (blockName = React.language("app.dock"));
    block.id === "flowManagementV2" &&
      (blockName = React.language("flow.toDo"));

    const appCount = this.state.apps.reduce((acc, item) => {
      return acc + item.apps.length;
    }, 0);

    if (block.id.includes("speedyEntryV2") || block.id === "speedyEntry") {
      let ars = [];
      if (preferences[block.id].entries) {
        if (Array.isArray(preferences[block.id].entries)) {
          ars = preferences[block.id].entries;
        } else {
          for (let key in preferences[block.id].entries) {
            ars.push(preferences[block.id].entries[key]);
          }
        }
      }
      let speedyEntryV2ref = null
      let oldData = JSON.stringify(preferences[block.id])
      let _this = this
      function emitClosePan() {
        if (_this.BsySpeedyContext.state.title === JSON.parse(oldData).title && _this.BsySpeedyContext.state.layoutStyle === JSON.parse(oldData).layoutStyle && JSON.stringify(_this.BsySpeedyContext.state.dataList) === JSON.stringify(JSON.parse(oldData).entries)) {
          speedyEntryV2ref.closeAlterMyApp();
        } else {
          BsyAlert({
            title: React.language("contact.dailog.over.title"),
            msg: React.language("contact.dailog.over.tip"),
            type: "warning",
            text4Ok: React.language("ok"),
            OkType: "red",
            text4Cancel: React.language("cancel"),
            ok: () => {
              speedyEntryV2ref.closeAlterMyApp();
            }
          })
        }
      }
      BsySlidePane({
        title: React.language("speedy.entry"),
        getContext: this.getSlideContext,
        hasCloseReturnDailog: true,
        onContentCreate: (ref) => {
          speedyEntryV2ref = ref;
          return (
            <BsyDesignSpeedyEntryConfig
              title={preferences[block.id].title}
              layoutStyle={preferences[block.id].layoutStyle}
              getSlideContext={this.BsySlideSpeedyContext}
              emitClosePan={emitClosePan}
              BsySlideContext={this.getSpeedyContext}
              speedyEntry={_.cloneDeep(preferences[block.id])}
              dataList={_.cloneDeep(ars)}
              slidePaneRef={ref}
              BsyDesignSpeedyContext={this}
            />
          );
        },
        onClose: () => {
          if (this.BsySpeedyContext.state.title === JSON.parse(oldData).title && this.BsySpeedyContext.state.layoutStyle === JSON.parse(oldData).layoutStyle && JSON.stringify(this.BsySpeedyContext.state.dataList) === JSON.stringify(JSON.parse(oldData).entries)) {
            return true
          } else {
            BsyAlert({
              title: React.language("contact.dailog.over.title"),
              msg: React.language("contact.dailog.over.tip"),
              type: "warning",
              text4Ok: React.language("ok"),
              OkType: "red",
              text4Cancel: React.language("cancel"),
              ok: () => {
                speedyEntryV2ref.closeAlterMyApp();
              }
            })
            return false
          }
        },
      });
    } else if (block.id === "noticeBoard") {
      this.settingNoticeBordConfigDiaolog();
    } else if (block.id === "myDash") {
      if (appCount === 0) {
        BsyAlert({
          title: React.language("not.create.report"),
          type: "warning",
          text4Ok: React.language("ok"),
          OkType: "blue",
          ok: () => { },
          text4Cancel: React.language("cancel"),
        });
        return;
      }

      BsyDialog({
        title: React.language("add.my.dash"),
        height: 560,
        width: 500,
        noFooter: false,
        okText: React.language("ok"),
        cancelText: React.language("cancel"),
        onOk: () => {
          if (this.myDash) {
            if (this.myDash.dash.length >= 20) {
              tipAlert({
                msg: React.language("add.max.count.tip", {
                  count: 20,
                }),
                type: "warning",
              });
              return;
            }
            let newMyDash = this.myDash.dash.map((item) => {
              //新表长宽固定
              return {
                ...item,
                width: 20,
                height: 20,
              };
            });
            let oldMyDash = _.cloneDeep(this.state.myDash.dash); //已有的表长宽不做修改
            newMyDash = newMyDash.map((item) => {
              let match = oldMyDash.find(
                (newItem) => newItem.widgetId === item.widgetId
              );
              return match ? { ...item, ...match } : item;
            });
            this.myDash.dash = newMyDash;

            this.setState(
              {
                speedyEntry: this.speedyEntry,
                dockApp: this.dockApp,
                customApp: this.customApp,
                myDash: this.myDash,
              },
              () => {
                // this.update_custom();
                // this.onDockApp(this.dockApp);
                // this.onMyDash(this.myDash);
                // this.onCustomApp(this.customApp);
                // this.onSpeedyEntry(this.speedyEntry);
              }
            );
          }
        },
        onContentCreate: () => {
          return this.renderCofigPane();
        },
      });
    } else if (block.id === "favorites") {
      this.favorites = this.state.favorites;

      if (appCount === 0) {
        BsyAlert({
          title: React.language("not.create.app.form.dash"),
          type: "warning",
          text4Ok: React.language("ok"),
          OkType: "blue",
          text4Cancel: React.language("cancel"),
          ok: () => { },
        });
        return;
      }

      BsyDialog({
        title: React.language("app.favorites"),
        height: 560,
        width: 500,
        noFooter: false,
        okText: React.language("ok"),
        cancelText: React.language("cancel"),
        onOk: () => {
          this.updateFavorites(this.favorites);
        },
        onContentCreate: () => {
          return this.renderCofigPane();
        },
      });
    } else if (block.id === "carouselMap") {
      this.settingCarouselMapConfigDiaolog();
    } else if (block.id === "flowManagementV2") {
      BsyMsgBubble({
        anchor: e.currentTarget,
        contentHTML: () => {
          return (
            <ul
              className={classNames(
                "t-flowManagement-sette " + flowManagementType
              )}
            >
              <li
                onClick={() => {
                  this.flowManagementTypeChange("card-cross");
                }}
              >
                <div>{React.language("speedyEntry.card.style.horizontal")}</div>
                <i className="icon-ok"></i>
              </li>
              <li
                onClick={() => {
                  this.flowManagementTypeChange("card-vertical");
                }}
              >
                <div>{React.language("speedyEntry.card.style.row")}</div>
                <i className="icon-ok"></i>
              </li>
              <li
                li
                onClick={() => {
                  this.flowManagementTypeChange("combo");
                }}
              >
                <div>{React.language("speedyEntry.card.list.style")}</div>
                <i className="icon-ok"></i>
              </li>
            </ul>
          );
        },
        text4Cancel: null,
        text4Ok: null,
        contentPadding: 0,
        edge: 200,
        dockPosition: "left",
        onClose: function () {
          return !1;
        },
      });
    } else if (block.id === "richText") {
      let transformStyle = window
        .$(".react-grid-richText")
        .css("transform")
        .replace(/[^0-9\-,]/g, "")
        .split(",");
      let scrollTop = window.$(".bsy-frame-content").scrollTop();
      console.log(
        window
          .$(".react-grid-richText")
          .css("transform")
          .replace(/[^0-9\-,]/g, "")
      );
      let Xnum = parseInt(transformStyle[4]) + 191;
      let Ynum = parseInt(transformStyle[5]) + 113 - scrollTop;
      let width = window.$(".react-grid-richText").width();
      let height = window.$(".react-grid-richText").height() + 40;
      this.BsyDialogBgFull = BsyDialogBgFull({
        //BsyDialogBgFull
        title: blockName + " " + React.language("setting"),
        height: "100%",
        width: "100%",
        noFooter: true,
        okText: null,
        cancelText: null,
        coloseModel: () => {
          _this.richTextClick = "rich-text-show";
          let richText = _this.state.richText || {};
          _this.bsyRichTextConfig.current.checkFn();
          if (_this.bsyRichTextConfig.current.checkFn()) {
            let html = _this.bsyRichTextConfig.current.state.editorState.toHTML()
            richText.html = html;
            if (html.substring(0, 7) === "<p></p>") {
              richText.html = html.substring(7)
            }
            if (richText.html === "<p></p>") {
              richText.html = "";
            }

            _this.props.onEmitEidtstate(false, richText);
            _this.setState({
              richText: richText,
            });
            return true;
          } else {
            return false;
          }
        },
        onContentCreate: () => {
          return (
            <div
              className={"rich-text-config-comment " + richText.imgSetvalue}
              style={{
                transform: "translate(" + Xnum + "px, " + Ynum + "px)",
                width: width + "px",
                height: height - 40 + "px",
                background:
                  block.id === "richText" &&
                  richText.bgData === "solidColor" &&
                  (richText.richTextActiveColor || "#fff"),
                backgroundImage:
                  block.id === "richText" &&
                  richText.bgData === "img" &&
                  !_.isEmpty(richText.imgFile) &&
                  (richText.imgFile.previewUrl
                    ? "url(" + richText.imgFile.previewUrl + ")"
                    : window.FX.CONFIG.HOST.IMAGE_HOST +
                    "/" +
                    richText.imgFile.qnKey),
              }}
            >
              <BsyDashRichTextConfig
                ref={this.bsyRichTextConfig}
                mode={mode}
                block={block}
                richText={richText}
                designMode={designMode}
              ></BsyDashRichTextConfig>
            </div>
          );
        },
      });
    } else {
      BsyDialog({
        title: blockName + " " + React.language("setting"),
        height: 600,
        width: 720,
        noFooter: false,
        okText: React.language("ok"),
        cancelText: React.language("cancel"),
        onOk: () => {
          this.setState(
            {
              speedyEntry: this.speedyEntry,
              dockApp: this.dockApp,
              customApp: this.customApp,
            },
            () => {
              // this.update_custom();
              this.onDockApp(this.dockApp);
              this.onMyDash(this.myDash);
              this.onCustomApp(this.customApp);
              this.onSpeedyEntry(this.speedyEntry);
            }
          );
        },
        onContentCreate: () => {
          return this.renderCofigPane();
        },
      });
    }
  };

  updateFavorites = (favorites, hasCb) => {
    React.axios("/dashboard/favorite_update_all", {
      favorites: favorites.map((item) => {
        if (item.type === "app") {
          return {
            type: "app",
            appId: item.value.appId,
          };
        }

        return {
          type: "entry",
          appId: item.value.appId,
          entryId: item.value.entryId,
        };
      }),
    }).then(() => {
      this.setState(
        {
          favorites: favorites,
        },
        () => {
          if (hasCb === false) return;
          this.favoritesContext?.favoritesList();

          const newApps = this.state.apps.map((item) => {
            return {
              ...item,
              apps: item.apps.map((res) => {
                if (
                  favorites.find((it) => {
                    return it.type === "app"
                      ? it.value.appId === res._id
                      : false;
                  })
                ) {
                  return {
                    ...res,
                    isFavorite: true,
                  };
                }
                return {
                  ...res,
                  isFavorite: false,
                };
              }),
            };
          });

          this.props.onUpdataApps(newApps, true);
        }
      );
    });
  };

  emitSettingNotice = () => {
    this.settingNoticeBordConfigDiaolog();
  };
  emitSettingCarouselMap = () => {
    this.settingCarouselMapConfigDiaolog();
  };
  settingNoticeBordConfigDiaolog = () => {
    const { noticeBoard, block } = this.state;
    let noticeBoardSlidePane = null
    let _this = this
    function emitClosePan() {
      if (_.isEmpty(noticeBoard) || (JSON.stringify(noticeBoard) === JSON.stringify(_this.boardNoticeBoardConfig.current.reseveoticeBoard()))) {
        noticeBoardSlidePane.closeAlterMyApp();
      } else {
        BsyAlert({
          title: React.language("contact.dailog.over.title"),
          msg: React.language("contact.dailog.over.tip"),
          type: "warning",
          text4Ok: React.language("ok"),
          OkType: "red",
          text4Cancel: React.language("cancel"),
          ok: () => {
            noticeBoardSlidePane.closeAlterMyApp();
          }
        })
      }
    }
    BsySlidePane({
      title: React.language("app.notice.board"),
      getContext: this.getNoticeSlideContext,
      hasCloseReturnDailog: true,
      onContentCreate: (ddf) => {
        noticeBoardSlidePane = ddf
        return (
          <BsyDashboardNoticeBoardConfig
            getNoticeSlideContext={this.BsyNoticeSlideSpeedyContext}
            ref={this.boardNoticeBoardConfig}
            block={block}
            noticeBoard={_.cloneDeep(noticeBoard)}
            emitClosePan={emitClosePan}
            emitSaveBoardNotice={this.emitSaveBoardNotice}
          />
        );
      },
      onClose: () => {
        if (_.isEmpty(noticeBoard) || (JSON.stringify(noticeBoard) === JSON.stringify(_this.boardNoticeBoardConfig.current.reseveoticeBoard()))) {
          return true
        } else {
          BsyAlert({
            title: React.language("contact.dailog.over.title"),
            msg: React.language("contact.dailog.over.tip"),
            type: "warning",
            text4Ok: React.language("ok"),
            OkType: "red",
            text4Cancel: React.language("cancel"),
            ok: () => {
              noticeBoardSlidePane.closeAlterMyApp();
            }
          })
          return false
        }

      }
    });
  };
  settingCarouselMapConfigDiaolog = () => {
    BsyDialog({
      title: React.language("setting") + React.language("app.carousel.map"),
      width: 520,
      noFooter: false,
      customCls: "t-carouse-map-dialog",
      okText: React.language("ok"),
      cancelText: React.language("cancel"),
      onOk: () => {
        this.onEmitCarousel(
          this.bsyDashboardCarouselMapConfig.current.emitData(),
          this.bsyDashboardCarouselMapConfig.current.getValue()
        );
      },
      onContentCreate: () => {
        return this.renderCofigPane();
      },
    });
  };
  toUpdateGroupData = (apps) => {
    let data = {
      app_group_list: [],
      app_list: [],
    };

    apps.map((group) => {
      data.app_group_list.push({
        _id: group._id,
        name: group.name,
      });
      (group.apps || []).map((app) => {
        data.app_list.push({
          _id: app._id,
          group_id: group._id,
        });
        return null;
      });

      return null;
    });
    return data;
  };

  updateGroup = (apps, onclose) => {
    const data = this.toUpdateGroupData(apps);
    React.axios("/dashboard/app_group/update", data)
      .then(() => {
        this.setState({ apps }, () => {
          onclose();
          this.props.onUpdataApps(apps);
        });
      })
      .catch(() => { });
  };
  emitSetRichData = (val) => {
    let richText = this.state.richText || {};
    richText.richTextActiveColor = val.richTextActiveColor;
    richText.bgData = val.bgData;
    richText.imgFile = val.imgFile;
    richText.imgSetvalue = val.imgSetvalue;
    richText.okColorHooseList = val.okColorHooseList;
    this.setState({
      richText: richText,
    });
  };
  onAppGroupSetting = () => {
    let apps = this.state.apps;
    let oldApps = JSON.stringify(this.state.apps)
    let groupsetingref = null;
    let groupConfigRef = React.createRef();

    BsySlidePane({
      title: React.language("app.group"),
      hasCloseReturnDailog: true,
      onContentCreate: (ref) => {
        groupsetingref = ref;
        return (
          <BsyDashboardAppGroupDesign
            ref={groupConfigRef}
            apps={this.state.apps}
            onChange={(res) => {
              apps = res;
            }}
          />
        );
      },
      hasFooter: true,
      onClose: () => {
        if (oldApps === JSON.stringify(apps)) {
          return true
        } else {
          BsyAlert({
            title: React.language("contact.dailog.over.title"),
            msg: React.language("contact.dailog.over.tip"),
            type: "warning",
            text4Ok: React.language("ok"),
            OkType: "red",
            text4Cancel: React.language("cancel"),
            ok: () => {
              groupsetingref.closeAlterMyApp();
            }
          })
          return false
        }
      },
      onFooter: () => {
        return (
          <div
            className="menu"
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <BsyIconBtn
              text={React.language("cancel")}
              click={() => {
                groupsetingref.closeAlter();
              }}
              type={"white"}
              mode={window.mode}
            ></BsyIconBtn>
            <BsyIconBtn
              text={React.language("save")}
              click={() => {
                if (BsyUtils.isObjectEmpty(apps)) return;

                if (groupConfigRef.current?.checkGroup()) {
                  return;
                }

                this.updateGroup(apps, () => {
                  groupsetingref.closeAlterMyApp();
                });
              }}
              type={"blue"}
              mode={window.mode}
            ></BsyIconBtn>
          </div>
        );
      },
    });
  };
  chooseRichTextBgImg = (event) => {
    event.stopPropagation();
    event.preventDefault();
    BsyMsgBubble({
      anchor: event.currentTarget,
      contentHTML: () => {
        return (
          <RichTextBackGroundImg
            emitSetRichData={this.emitSetRichData}
            richText={this.state.richText}
          ></RichTextBackGroundImg>
        );
      },
      text4Cancel: null,
      text4Ok: null,
      contentPadding: 0,
      edge: 200,
      dockPosition: "left",
      onClose: function () {
        return !1;
      },
    });
  };
  onExportApp = () => {
    BsyDialog({
      title: React.language("app.batch.export.title"),
      width: 800,
      height: 580,
      noFooter: false,
      okText: React.language("ok"),
      cancelText: React.language("cancel"),
      onOk: () => {
        this.exportApp.current.exportPane._export();
      },
      onContentCreate: (ref) => {
        return <BsyAppExportPane ref={this.exportApp} dialogRef={ref} />;
      },
    });
  };

  renderUpdateApp = () => {
    return "";

    // const { block, mode } = this.state;
    // if (mode !== "edit" && block.id === "myApp" && BsyUtils.isSysManager()) {
    //   return (
    //     <div class="update-notification">
    //       <div class="notification-content">
    //         <span class="icon">💡</span>
    //         <span class="text">有新的应用可更新</span>
    //       </div>

    //       <BsyIconBtn
    //         text={React.language("go.update")}
    //         click={() => {
    //           this.myAppRef?.current?.openUpdateStandardAppPane?.();
    //         }}
    //         type={"blue"}
    //         mode={window.mode}
    //       ></BsyIconBtn>
    //     </div>
    //   );
    // }

    // return "";
  };

  renderTitle = () => {
    const {
      block,
      mode,
      dockCorp,
      dockApp,
      hasStandardAppUpdate,
      noticeBoard,
      preferences,
      apps,
    } = this.state;

    const count = apps.reduce((acc, app) => acc + app.apps.length, 0);

    const that = this;
    let blockName = block.name;
    let dockCorpList = [];
    block.id.includes("speedyEntryV2") &&
      (blockName =
        preferences[block.id]?.title || React.language("speedy.entry"));
    block.id === "speedyEntry" &&
      (blockName =
        preferences[block.id]?.title || React.language("speedy.entry"));
    block.id === "customApp" && (blockName = React.language("app.common"));
    block.id === "favorites" && (blockName = React.language("app.favorites"));
    block.id === "dockApp" && (blockName = React.language("app.dock"));
    block.id === "carouselMap" && (blockName = "");
    block.id === "flowManagementV2" && (blockName = "");
    if (block.id === "noticeBoard") {
      if (!noticeBoard.isShowTitle) {
        blockName = "";
      } else {
        blockName = noticeBoard.titleName;
      }
    }

    block.id === "myDash" && (blockName = React.language("dash.mine"));
    if (block.id === "dockApp") {
      dockCorp.map((res) => {
        dockCorpList.push({
          value: res._id,
          text: res.name,
        });
        return null;
      });
    }

    if (block.id === "myApp" && BsyUtils.isSysManager()) {
      let c = 2;

      return (
        <div
          className={`myAppTitle setitem-${c}`}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <span className="title">{React.language("app.mine")}</span>

          {mode !== "edit" ? (
            <>
              {count === 0 ? (
                ""
              ) : (
                <>
                  <span
                    className="setting-item"
                    onClick={this.onAppGroupSetting}
                    onMouseEnter={(e) => {
                      this.showTooltip(
                        e.currentTarget,
                        React.language("setting.app.group"),
                        "bottom",
                        10
                      );
                    }}
                    onMouseLeave={() => {
                      this.hideTooltip();
                    }}
                  >
                    <span>
                      <i className={"icon-bsy-iconshezhi1"}></i>
                      {React.language("setting")}
                    </span>
                  </span>
                  <span
                    className="setting-item"
                    onClick={this.onExportApp}
                    onMouseEnter={(e) => {
                      this.showTooltip(
                        e.currentTarget,
                        React.language("app.batch.export1"),
                        "bottom",
                        10
                      );
                    }}
                    onMouseLeave={() => {
                      this.hideTooltip();
                    }}
                  >
                    <span>
                      <i className={"icon-bsy-reportmenu-7"}></i>
                      {React.language("export")}
                    </span>
                  </span>
                  {hasStandardAppUpdate && (
                    <span
                      className="setting-item"
                      data-for="update-app"
                      data-tip={React.language("update.app")}
                      onClick={() => {
                        that.myAppRef?.current?.openUpdateStandardAppPane?.();
                      }}
                      onMouseEnter={(e) => {
                        this.showTooltip(
                          e.currentTarget,
                          React.language("update.app"),
                          "bottom",
                          10
                        );
                      }}
                      onMouseLeave={() => {
                        this.hideTooltip();
                      }}
                    >
                      <span>
                        <i className="icon-bsy-reportmenu-15"></i>
                        <span>{React.language("update.app")}</span>
                      </span>
                    </span>
                  )}
                </>
              )}
            </>
          ) : (
            ""
          )}
        </div>
      );
    }

    return block.id === "flowManagement" ? (
      ""
    ) : block.id === "dockApp" ? (
      <div className="doc-app-left">
        <span className="title">{blockName}</span>
        {mode !== "edit" && <BsySelect
          value={dockApp.corp ? dockApp.corp : dockCorpList?.[0]?.value}
          items={dockCorpList}
          minWidth={200}
          height={32}
          allowBlank={false}
          customCls={"province"}
          onStopEdit={(e1) => {
            let DockAppVal = dockApp;
            DockAppVal.corp = e1;
            this.setState(
              {
                dockApp: DockAppVal,
              },
              () => {
                this.setcacheValue(DockAppVal);
                this.onDockApp(DockAppVal);
              }
            );
          }}
        />}
      </div>
    ) : (
      <>
        <span className="title">{blockName}</span>
        {[
          "customDash",
          "recentUse",
          "myApp",
          "customApp",
          "favorites",
          "myDash",
        ].includes(block.id) ? (
          ""
        ) : mode === "edit" ? (
          <div>
            <span className={"setting " + block.id} onMouseDown={this.onConfig}>
              {block.id === "richText" && (
                <i className="icon-bsy-reportmenu-1"></i>
              )}
              {block.id !== "richText" && (
                <i className={"icon-bsy-iconshezhi1"}></i>
              )}
            </span>
            {block.id === "richText" && (
              <span className="rich-icon">
                <i
                  className="icon-bg-cont"
                  onMouseDown={this.chooseRichTextBgImg}
                ></i>
              </span>
            )}
          </div>
        ) : (
          ""
        )}
        {["myDash", "favorites"].includes(block.id) && mode !== "edit" ? (
          <div className="addMyDash" onMouseDown={this.onConfig}>
            <i className={"icon-add"}></i>
            <span>{React.language("add")}</span>
          </div>
        ) : (
          ""
        )}
      </>
    );
  };

  onLayout = (block) => {
    if (this.props.onFlowManagement) {
      this.props.onFlowManagement(block);
    }
  };

  onAddApp = () => {
    BsyDialog({
      title: React.language("webhook.key.create.app"),
      width: 996,
      height: 500,
      noFooter: true,
      onContentCreate: () => {
        return (
          <CreateApp
            title={React.language("webhook.key.create.app")}
            apps={this.state.apps}
          />
        );
      },
    });
  };

  toTarget = (app, n, s) => {
    this.setState(
      {
        seach: false,
      },
      () => {
        if (app.type === "app") {
          let appCache = BsyUtils.getEntryCache(app._id);
          if (BsyUtils.isObjectEmpty(appCache)) {
            this.props.history.push(
              window.rootDirectroy + "/team/app/" + app._id
            );
          } else {
            this.props.history.push(
              `${window.rootDirectroy}/team/app/${appCache.appid}/${appCache.type}/${appCache.entryid}`
            );
          }

          // this.props.history.push(`/team/app/${app._id}`)
        } else {
          this.props.history.push(
            `${window.rootDirectroy}/team/app/${app.appId}/${app.type}/${app.entryId}`
          );
        }
        s && s.closeAlter();
        window.location.reload();
      }
    );
  };

  renderOperateBtn = () => {
    const { block, mode, apps } = this.state;
    if (mode !== "edit") {
      if (block.id === "myApp" || block.id === "dockApp") {
        const count = apps.reduce((acc, app) => acc + app.apps.length, 0);
        if (count === 0) {
          return "";
        }

        if (BsyUtils.isCorpOwn() || BsyUtils.isSysManager()) {
          return (
            <div className="app-tool">
              <div className="item item-left">
                <BsySearchResult
                  autoClose={false}
                  dockPosition="center"
                  ref={this.searchResultRef}
                  async={{
                    url: "/dashboard/search",
                    data: {
                      type: "all",
                      mode: "all",
                      range: this.props.isStandard ? "standard" : "noStandard",
                    },
                    sucess: (items) => {
                      return items.list;
                    },
                  }}
                  // inputValue={searchValue}
                  minHeight={100}
                  maxHeight={350}
                  onBlur={() => {
                    this.setState(
                      {
                        showSearch: false,
                      },
                      () => {
                        this.props?.onShowSearch?.(false);
                      }
                    );
                    return false;
                  }}
                  placeholder={React.language("searchAppForm")}
                  onCreatResult={(res, s) => {
                    let appItem = [];
                    let otherItem = [];
                    if (res && res.length > 0) {
                      res.map((val) => {
                        if (val.type !== "app") {
                          otherItem.push(val);
                        } else {
                          appItem.push(val);
                        }
                        return null;
                      });
                    }
                    return res && res.length > 0 ? (
                      <div className="searchAllAppFormReport">
                        <ul className="searchFormDashReport">
                          {
                            otherItem.length > 0
                              ? otherItem.map((val) => {
                                return (
                                  val && (
                                    <li
                                      key={val.id}
                                      onClick={() => {
                                        this.toTarget(val, null, s);
                                      }}
                                    >
                                      <div className="contView">
                                        <div
                                          className="menu-item"
                                          title={val.text}
                                        >
                                          <i
                                            className={`node-icon icon-bsy-${val.type
                                              }${!val.hasCoop ? "-flow" : ""} ${val.icon > 24
                                                ? "icon-new-bsy-form-" +
                                                val.icon
                                                : `icon-bsy-form-${val.icon}`
                                              }`}
                                          />
                                          <span
                                            dangerouslySetInnerHTML={{
                                              __html: val.titleHtml,
                                            }}
                                          />
                                        </div>
                                        <div className="appNameItem">
                                          <span>{val.appName}</span>
                                        </div>
                                        {val.mode === "dock" && (
                                          <div
                                            className="dockItem"
                                            title={
                                              React.language(
                                                "organization.external"
                                              ) +
                                              ":" +
                                              val.corp_name
                                            }
                                          >
                                            {React.language(
                                              "organization.external"
                                            ) +
                                              ":" +
                                              val.corp_name}
                                          </div>
                                        )}
                                      </div>
                                    </li>
                                  )
                                );
                              })
                              : ""
                            // <li className="emptySearchForm">
                            //   {React.language("dash.form.empty")}
                            // </li>
                          }
                        </ul>
                        <ul className="searchApp dock">
                          {
                            appItem.length > 0
                              ? appItem.map((val) => {
                                return (
                                  val && (
                                    <li
                                      key={val.id}
                                      onClick={() => {
                                        this.toTarget(val, "isApp", s);
                                      }}
                                    >
                                      <div className="appItem">
                                        <div
                                          className={
                                            "app-icon color-cover-" +
                                            val.style.color
                                          }
                                        >
                                          <div
                                            className={
                                              "imgbg-small-bsy-app imgbg-bsy-app-" +
                                              val.style.icon
                                            }
                                          />
                                        </div>
                                        <span
                                          dangerouslySetInnerHTML={{
                                            __html: val.titleHtml,
                                          }}
                                        />
                                      </div>
                                      {val.mode === "dock" && (
                                        <div
                                          className="dockItem"
                                          title={
                                            React.language(
                                              "organization.external"
                                            ) +
                                            ":" +
                                            val.corp_name
                                          }
                                        >
                                          {React.language(
                                            "organization.external"
                                          ) +
                                            ":" +
                                            val.corp_name}
                                        </div>
                                      )}
                                    </li>
                                  )
                                );
                              })
                              : ""
                            // <li className="emptySearchForm">
                            //   {React.language("app.all.empty")}
                            // </li>
                          }
                        </ul>
                      </div>
                    ) : (
                      <div className="emptySearchAll">
                        {React.language("field.location.empty")}
                      </div>
                    );
                  }}
                />
              </div>
              {
                block.id === "myApp" && <div className="item ">
                  <BsyIconBtn
                    text={React.language("webhook.key.create.app")}
                    click={this.onAddApp}
                    type={"blue"}
                    iconName={"icon-bsy-add"}
                    mode={window.mode}
                  ></BsyIconBtn>
                </div>
              }

            </div>
          );
        }

        return "";
      }

      return "";
    }
    return (
      <div className="tool">
        {block.id === "flowManagement" ? (
          <div
            className={"item layout-btn"}
            style={{ right: "40px" }}
            ref={this.layoutBtn}
            onMouseDown={(e) => {
              this.onLayout(block);
              e.stopPropagation();
              e.preventDefault();
            }}
          >
            <i
              className={
                block.layout === "vertical"
                  ? "icon-bsy-iconpaixu"
                  : "icon-tongbu"
              }
            ></i>
          </div>
        ) : (
          ""
        )}
        {!["flowManagementV2", "dockApp"].includes(block.id) && (
          <div
            className="item del-btn"
            onMouseDown={(e) => {
              this.onDelComponent(block);
              e.stopPropagation();
              e.preventDefault();
            }}
          >
            <i className="icon-trasho"></i>
          </div>
        )}
      </div>
    );
  };

  getCustomDashWidget = () => {
    const { block, customDash } = this.state;
    if (!customDash.dash) {
      return {};
    }
    let widget = [];

    BsyUtils.forEach(customDash.dash, (index, data) => {
      if (
        [data.appId, data.entryId, data.widgetId].join("@") ===
        [block.appId, block.entryId, block.widgetId].join("@")
      ) {
        widget.push(data);
      }
    });

    // const widget = customDash.dash.filter((data, index) => {
    //     return [data.appId, data.entryId, data.widgetId].join("@") === [block.appId, block.entryId, block.widgetId].join("@")
    // })

    return widget.length
      ? {
        ...widget[0].widgetParams,
        appId: widget[0].appId,
        entryId: widget[0].entryId,
      }
      : {};
  };

  render() {
    const {
      block,
      speedyEntry,
      mode,
      customApp,
      dockApp,
      dockItem,
      designMode,
      dockCorp,
      myDash,
      favorites,
      carouselMap,
      recentUse,
      RecentUseList,
      noticeBoard,
      richText,
      flowManagementType,
      preferences,
    } = this.state;
    let dockAppList;
    if (!dockApp || !dockApp.corp) {
      dockAppList = dockItem?.[0];
    } else {
      dockItem.map((res) => {
        if (dockApp) {
          if (res._id === dockApp.corp) {
            dockAppList = res;
          }
        }
        return null;
      });
    }
    if (block.id === "invalidBlock") {
      return (
        <div
          className={`bsy-component ${block.id} ${block.layout} ${flowManagementType} ${mode}`}
          key={"BsyDashComponent1-" + block.widget}
        >
          <div className="content">
            <div class="component-menu">
              <span class="title">{block.name}</span>
              {mode === "edit" && (
                <div class="tool">
                  <div
                    class="item del-btn"
                    onMouseDown={(e) => {
                      this.onDelComponent(block);
                      e.stopPropagation();
                      e.preventDefault();
                    }}
                    onMouseEnter={(e) => {
                      this.showTooltip(
                        e.currentTarget,
                        React.language("delete"),
                        "bottom",
                        10
                      );
                    }}
                    onMouseLeave={() => {
                      this.hideTooltip();
                    }}
                  >
                    <i class="icon-trasho"></i>
                  </div>
                </div>
              )}
            </div>
            <div className="component-body">
              <div className="invalid-Block"> {block.msg} </div>
            </div>
          </div>
        </div>
      );
    }

    if (block.id === "customDash") {
      return (
        <div className={`t-customDash-view ${mode} ${designMode}`}>
          <BsyDashComponent
            env={mode === "edit" ? "dashboard" : ""}
            widget={this.getCustomDashWidget()}
            key={"BsyDashComponent1-" + block.widget + block.h + block.w}
            onGetStyles={this.onGetStyles}
            onDelComponent={() => {
              this.onDelComponent(block);
            }}
            onIsAutoLoad={() => {
              return true;
            }}
            operates={mode === "edit" ? ["delete"] : []}
          />
        </div>
      );
    }

    return (
      <div
        className={`bsy-component ${block.id} ${block.layout} ${flowManagementType} ${mode}`}
        key={"BsyDashComponent1-" + block.widget}
      >
        <div
          className={classNames(
            (["carouselMap", "richText", "flowManagementV2"].includes(
              block.id
            ) ||
              (block.id === "noticeBoard" &&
                !noticeBoard.isShowTitle &&
                !noticeBoard.isShowMoreTitle)) &&
              mode === "edit"
              ? "content no-title"
              : "content",
            richText.imgSetvalue
          )}
          style={{
            background:
              block.id === "richText" &&
              richText.bgData === "solidColor" &&
              richText.richTextActiveColor,
            backgroundImage:
              block.id === "richText" &&
              richText.bgData === "img" &&
              !_.isEmpty(richText.imgFile) &&
              (richText.imgFile.previewUrl
                ? "url(" + richText.imgFile.previewUrl + ")"
                : window.FX.CONFIG.HOST.IMAGE_HOST +
                "/" +
                richText.imgFile.qnKey),
          }}
        >
          {
            //访问状态 流程待办 不用显示菜单占行
            mode !== "edit" && block.id === "flowManagement" ? (
              ""
            ) : (
              <div className={"component-menu "}>
                {this.renderTitle()}

                {this.renderOperateBtn()}
              </div>
            )
          }
          <div
            className={classNames(
              "component-body" +
              " " +
              mode +
              " " +
              (block.id === "richText" ? this.richTextClick : "") +
              " " +
              (block.id === "carouselMap" &&
                ((carouselMap.files && carouselMap.files.length === 0) ||
                  _.isEmpty(carouselMap.files))
                ? "t-has-click"
                : " ") +
              " " +
              (block.id === "noticeBoard" &&
                (noticeBoard.styleType === "" ||
                  _.isEmpty(noticeBoard) ||
                  !noticeBoard.styleType)
                ? "t-has-click"
                : " ")
            )}
          >
            {block.id === "carouselMap" && (
              <BsyDashCarouselMap
                carouselMap={carouselMap}
                mode={mode}
                designMode={designMode}
                emitSettingCarouselMap={this.emitSettingCarouselMap}
                key={
                  block.x +
                  block.y +
                  block.w +
                  block.h +
                  this.changeStateCarouselMap
                }
              />
            )}
            {block.id === "recentUse" && (
              <BsyDashRecentUse
                recentUse={recentUse}
                mode={mode}
                block={block}
                designMode={designMode}
                RecentUseList={RecentUseList}
                onRefreshChars={this.props?.onRefreshChars?.()}
                onGetRecentUseValue={this.onGetRecentUseValue}
              />
            )}
            {block.id === "noticeBoard" && (
              <BsyDashNoticeBoard
                noticeBoard={noticeBoard}
                mode={mode}
                block={block}
                emitSettingNotice={this.emitSettingNotice}
                onRefreshChars={this.props?.onRefreshChars?.()}
                designMode={designMode}
              // key={Math.random()}
              />
            )}
            {block.id === "richText" && (
              <BsyDashRichText
                ref={this.bsyRichText}
                mode={mode}
                block={block}
                richText={richText}
                designMode={designMode}
                onConfig={this.onConfig}
              // key={Math.random()}
              />
            )}
            {/* {block.id === "flowManagement" && (
              <BsyDashboardFlowPane layout={block.layout} dockCorp={dockCorp} />
            )} */}
            {(block.id === "flowManagementV2" ||
              block.id === "flowManagement") && (
                <BsyDashboardFlowPaneV2
                  layout={block.layout}
                  // key={this.changeStateflowManagementV2}
                  key={
                    block.x +
                    block.y +
                    block.w +
                    block.h +
                    this.changeStateflowManagementV2
                  }
                  mode={mode}
                  block={block}
                  designMode={designMode}
                  flowManagementType={flowManagementType}
                  dockCorp={dockCorp}
                />
              )}
            {
              //快捷入口
              block.id === "speedyEntry" && (
                <BsyDashboardSpeedyEntry entrys={speedyEntry} />
              )
            }
            {
              //快捷入口
              !block.id.includes("speedyEntryV2") ? (
                ""
              ) : (
                <>
                  <BsyDashboardSpeedyEntry
                    entrys={preferences[block.id]}
                    mode={mode}
                    onSetEntry={this.onConfig}
                    onRefreshChars={this.props?.onRefreshChars?.()}
                  />
                  {/* {mode === "edit" && (
                        <div className="panel-tip">
                          {React.language("dashboard.all.entry.tip")}
                        </div>
                      )} */}
                </>
              )
            }
            {block.id === "customApp" && (
              <>
                <BsyDashboardCustomApp customApp={customApp} mode={mode} />
                {mode === "edit" && (
                  <div className="panel-tip">
                    {React.language("dashboard.all.app.tip")}
                  </div>
                )}
              </>
            )}
            {block.id === "myApp" && (
              <>
                <BsyDashboardMyApp
                  ref={this.myAppRef}
                  apps={this.state.apps}
                  customApp={customApp}
                  onUpdataApps={this.props.onUpdataApps}
                  mode={mode}
                  onRefreshChars={this.props.onRefreshChars}
                  onStandardAppUpdate={(hasStandardAppUpdate) => {
                    this.setState({
                      hasStandardAppUpdate,
                    });
                  }}
                />
                {mode === "edit" && (
                  <div className="panel-tip">
                    {React.language("dashboard.all.app.tip")}
                  </div>
                )}
              </>
            )}
            {/* 外部应用 */}
            {block.id === "dockApp" && (
              <>
                <BsyDashboardDockApp dockApp={dockAppList} mode={mode} />
                {mode === "edit" && (
                  <div className="panel-tip">
                    {React.language("dashboard.all.app.tip")}
                  </div>
                )}
              </>
            )}
            {block.id === "myDash" && ( //我的图表
              <>
                {mode === "edit" ? (
                  <div className="myDashTip">
                    <span>{React.language("my.chart.view.desc")}</span>
                  </div>
                ) : (
                  <BsyDashboardMyDash
                    onRefreshChars={this.props?.onRefreshChars}
                    onAddDash={this.onConfig}
                    onDelComponent={(data) => {
                      const dash = this.state.myDash.dash.filter((item) => {
                        return (
                          item.appId !== data.appId ||
                          item.entryId !== data.entryId ||
                          item.widgetId !== data.widgetId
                        );
                      });
                      this.myDash = {
                        ...myDash,
                        dash,
                      };
                      this.setState({
                        myDash: {
                          ...myDash,
                          dash,
                        },
                      });
                    }}
                    myDash={myDash}
                    mode={mode}
                    onItemsChange={(dash) => {
                      dash.map((it) => {
                        console.log("onItemsChange", {
                          name: it.widgetParams.title,
                          height: it.height,
                          width: it.width,
                        });
                        return null;
                      });
                      this.setState({
                        myDash: {
                          ...myDash,
                          dash,
                        },
                      });
                    }}
                  />
                )}
              </>
            )}
            {block.id === "favorites" && (
              <>
                {mode === "edit" ? (
                  <div className="myDashTip">
                    <span>{React.language("my.chart.favorites.desc")}</span>
                  </div>
                ) : (
                  <BsyDashboardMyFavorites
                    onRefreshChars={(favorites) => {
                      this.setState(
                        {
                          favorites,
                        },
                        () => {
                          this.props?.onRefreshChars?.();
                        }
                      );
                    }}
                    onAddFavorites={this.onConfig}
                    updateFavorites={this.updateFavorites}
                    onUpdataApps={this.props.onUpdataApps}
                    apps={this.state.apps}
                    favorites={favorites}
                    getContext={(el) => {
                      this.favoritesContext = el;
                    }}
                  />
                )}
              </>
            )}
            {block.id !== "filter" ? "" : ""}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(BsyDashboardComponent);
